import { isEmail } from 'validator';

const isValidEmailAddress = (email: string): boolean => {
	return isEmail(email);
};

export const emailUtil = {
	isValidEmailAddress
};
